import React from 'react';
import { Navigate, NavLink } from 'react-router-dom';
import getRecruiterInfo from '../../services/getRecruiterInfo';
import { auth as AuthObject } from '../../services/login'
import './header.scss';
import cookie from '../../cookieHelper/cookie';
import { HOME_ROUTE } from '../../models/routes';
import logo from '../../images/spotlightLogo.svg'

class Header extends React.Component {
    
    constructor() {
        super();
        this.state = {
            redirect: false,
            redirectSL:false,
            redirectIS:false,
            redirectAS:false,
            redirectAC:false,
            redirectReport : false

        }

        this.setRecHeader();
    }

    setRecHeader = () =>{
        this.loginProfileInfo = JSON.parse(cookie.getCookie('loginProfileInfo'));
        // console.log("Inside Header Function:",this.loginProfileInfo.email);
        this.state.name = this.loginProfileInfo.name;
        this.state.email = this.loginProfileInfo.email;
    }

    cookieRemoveHandler = () => {
        cookie.delete_cookie(process.env.REACT_APP_COOKIE_NAME);
        cookie.delete_cookie('loginProfileInfo');
        AuthObject.isAuthenticated = false;
        this.setState({ 
            redirect: true,
            redirectSL:false,
            redirectIS:false,
            redirectAS:false,
            redirectAC:false,
            redirectReport : false
        });
    }

    
    redirectToStoryListing = () =>{
        this.setState({
            redirectSL:true,
        })
        
        
    }
    redirectToInviteScreen = () =>{
        if(this.state.redirectIS==false){
            this.setState({
                redirectIS:true
            })
        }
        
    }
    redirectToAdminScreen = () =>{
        this.setState({
            redirectAS:true,
        })
    }

    redirectToAddCompany = () =>{
        this.setState({
            redirectAC:true,

        })
    }
    redirectToReport = () =>{
        this.setState({
            redirectReport:true,

        })
    }
   
    handleClick(e) {
        e.stopPropagation();
        var ui = document.querySelector(".profile-menu");
        


        if (ui.style.display == "none") {
            ui.style.display = "block";
        }
        else {
            ui.style.display = "none";
        }
    }
    // componentDidMount(){
    //     console.log(this.state.redirectAS);
    // }
    // componentDidUpdate(){
    //     console.log(this.state.redirectAS);
    // }
    // shouldComponentUpdate(){
    //     console.log(this.state.redirectAS);
    // }
    render() {
        if (this.state.redirect) {
            // console.log("2");
            console.log("redirecting after logout");
            
            return <Navigate to={'/'} />
        }
        else if(this.state.redirectSL){
            return <Navigate to={'/Story'} />
        }
        else if(this.state.redirectIS){
            return <Navigate to= {'/user'} />
        }
        else if(this.state.redirectAS){
            return <Navigate to={'/adminUserScreen'} />
        }
        else if(this.state.redirectAC){
            return <Navigate to={'/Company'} />
        }
        else if(this.state.redirectAC){
            return <Navigate to={'/report'} />
        }

        return (
            <header >
                <div className="container" >
                    <div id="branding">
                        {/* <img src="https://www.talsup.com/static/images/talsup-logo.png" alt="" className="showcaseBranding" /> */}
                        {/* <img src="../../images/spotlightLogo.svg" alt="" className="showcaseBranding" /> */}
                        <NavLink to={HOME_ROUTE} aria-label="Home"><img src={logo} alt="" className="showcaseBranding" /></NavLink>

                    </div>
                    <div className="topnav">
                        {/* <a id="sl" className="" onClick={this.redirectToStoryListing}>Story Listing</a>
                        <a id="is" className="" onClick={this.redirectToInviteScreen}>Invite Screen</a>
                        <a id="as" className="" onClick={this.redirectToAdminScreen}>Make User Admin</a>
                        <a id="es" className="" onClick={this.redirectToEditScreen}>Edit Story</a>
                        <a id="ac" className="" onClick={this.redirectToAddCompany}> Add Company </a> */}


                        {/* <a id="sl" href="/Story" className="" onClick={this.redirectToStoryListing}>Story</a>
                        <a id="ac" href="/Company" className="" onClick={this.redirectToAddCompany}>Company</a>
                        <a id="is" href="/user" className="" onClick={this.redirectToInviteScreen}>User</a>
                        <a id="as" href="/adminUserScreen" className="" onClick={this.redirectToAdminScreen}>Make User Admin</a>
                        <a id="report" href="/report" className="" onClick={this.redirectToReport}>Report</a>                         */}
                        

                        <NavLink id="home" to={HOME_ROUTE}>Home</NavLink>
                        {/* <a id="sl" href="/Story" className="" >Story</a> */}
                        {/* <a id="ac" href="/Company" className="" >Company</a> */}
                        <a id="is" href="/user" className="" >User</a>
                        <a id="as" href="/adminUserScreen" className="">Make User Admin</a>
                        <a id="report" href="/report" className="" >Report</a>
                        <a id="story-insights" href="/storyInsights" className="" >Story Insights</a>
                        <a id="all-story" href="/allStories" className="" >All Stories</a>
                        {/* <a id="reel-insights" href="/reelInsights" className="" >Reel Insights</a> */}

                    </div>
                    <div className="profile action-icon profileImgAction" >
                        <img className="user_img" id="userImageMain" src="https://showcaseadmin.iimjobs.com/static/images/user_default.png" onClick={this.handleClick} />
                        <div className="profile-menu topMenu">
                            <div className="profile-header">
                                <p className="user-name user_name" id="profile-name" >{this.state.name}</p>
                                <p className="user-email user_email" id="profile-email" >{this.state.email}</p>
                            </div>
                            <div className="profile-body">
                                <ul className="profile-item-listing">
                                    <li className="logout recruiterLogout" onClick={this.cookieRemoveHandler}>Logout</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
        );
    }
}

export default Header;